import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestSelections(subscriber) {
  return () => ({
    type: Constants.REQUEST_SELECTIONS,
    subscriber
  });
}
export function receiveSelections(subscriber) {
  return (json, error) => ({
    type: Constants.RECEIVE_SELECTIONS,
    data: json,
    subscriber,
    error
  });
}
export function requestRemoveSelections(subscriber) {
  return () => ({
    type: Constants.REQUEST_REMOVE_SELECTIONS,
    subscriber
  });
}
export function receiveRemoveSelections(subscriber) {
  return (json, error) => ({
    type: Constants.RECEIVE_SELECTIONS,
    data: json,
    subscriber,
    error
  });
}
export function clearSelections() {
  return {
    type: Constants.RECEIVE_SELECTIONS,
    data: {}
  };
}
export function viewSelection(subscriber, jobId, blockId) {
  return {
    type: Constants.VIEW_SELECTION,
    subscriber,
    blockId,
    jobId
  };
}
export function requestProfileAudit(subscriber) {
  return () => ({
    type: Constants.REQUEST_PROFILE_AUDIT,
    subscriber
  });
}
export function receiveProfileAudit(subscriber) {
  return (json, error) => ({
    type: Constants.RECEIVE_PROFILE_AUDIT,
    data: json,
    subscriber,
    error
  });
}

export function requestEditProfileStatus(subscriber) {
  return () => ({
    type: Constants.REQUEST_EDIT_PROFILE_STATUS,
    subscriber
  });
}
export function receiveEditProfileStatus(subscriber) {
  return (json, error) => ({
    type: Constants.RECEIVE_EDIT_PROFILE_STATUS,
    data: json,
    subscriber,
    error
  });
}

export function getSelections(subscriberId, options = {}) {
  const qs = `?locale=${options.locale || ''}`;
  const path = `ecs/api/profile/${subscriberId}/selections${qs}`;
  return new Endpoint(
    path,
    requestSelections(subscriberId),
    receiveSelections(subscriberId)
  )
    .withOptions(options)
    .call();
}

export function removeSelections(subscriberId, options = {}) {
  const path = `ecs/api/profile/${subscriberId}/remove_interactions`;
  return new Endpoint(
    path,
    requestRemoveSelections(subscriberId),
    receiveRemoveSelections(subscriberId)
  )
    .withMethod('POST')
    .withOptions(options)
    .call();
}

export function getProfileAudit(subscriberId, options = {}) {
  const path = `ecs/api/profile/${subscriberId}/audit`;
  return new Endpoint(
    path,
    requestProfileAudit(subscriberId),
    receiveProfileAudit(subscriberId)
  )
    .withOptions(options)
    .call();
}

export function editProfileStatus(subscriberId, options = {}) {
  const path = `ecs/api/profile/${subscriberId}/status`;
  return new Endpoint(
    path,
    requestEditProfileStatus(subscriberId),
    receiveEditProfileStatus(subscriberId)
  )
    .withMethod('POST')
    .withBody(JSON.stringify(options))
    .withOptions(options)
    .call();
}
